import { t } from "i18next";

import StaticOverlayCard from "@/features/widget-forms/forms/weather-model-map/components/static-overlay-card";
import AddStaticOverlayModal from "@/features/widget-forms/forms/weather-model-map/modals/add-static-overlay-modal";
import { SortableItem, SortableList } from "@/features/admin/components/sortable-list";
import Icon from "@/components/icon/icon";
import styles from "@/features/widget-forms/forms/weather-model-map/weather-model-map-dialog.module.css";

import { useObservationsMapForm } from "./use-observations-map-form";

export function ObservationsMapStaticOverlaysPanel() {
  const {
    staticOverlays,
    staticOverlayConfigurations,
    selectedStaticOverlayIds,
    addStaticOverlay,
    removeStaticOverlay,
    reorderStaticOverlays,
    renameStaticOverlay,
    updateStaticOverlayColor,
    updateStaticOverlayEnabledByDefault,
  } = useObservationsMapForm();

  return (
    <div className={styles.settingsPanel}>
      <div className={styles.sectionHeader}>
        <AddStaticOverlayModal
          staticOverlays={staticOverlays ?? []}
          selectedStaticOverlayIds={selectedStaticOverlayIds}
          onAdd={addStaticOverlay}
        />
      </div>
      <div className={styles.settingsPanelCards}>
        {staticOverlayConfigurations.length > 0 ? (
          <SortableList
            onReorder={reorderStaticOverlays}
            className={styles.cardGrid}
            groupId="observations-static-overlays"
          >
            {staticOverlayConfigurations.map((overlay, index) => (
              <SortableItem key={overlay.static_map_overlay_id} index={index}>
                <StaticOverlayCard
                  config={overlay}
                  overlayInfo={staticOverlays?.find(
                    (o) => o.id === overlay.static_map_overlay_id,
                  )}
                  onRename={(text) =>
                    renameStaticOverlay(overlay.static_map_overlay_id, text)
                  }
                  onColorChange={(color) =>
                    updateStaticOverlayColor(overlay.static_map_overlay_id, color)
                  }
                  onEnabledByDefaultChange={(enabled) =>
                    updateStaticOverlayEnabledByDefault(
                      overlay.static_map_overlay_id,
                      enabled,
                    )
                  }
                  onRemove={() => removeStaticOverlay(overlay.static_map_overlay_id)}
                />
              </SortableItem>
            ))}
          </SortableList>
        ) : (
          <div className={styles.emptyState}>
            <Icon name="shapes" size={32} />
            <span className={styles.emptyStateText}>
              {t("admin.widgets.fields.observations_map.static_overlays.empty")}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
